export const IMPHEALTHSAFEGOALAction = {
    AddHealthSafeGoal: "ADDHEALTHSAFEGOAL",
    RemoveHealthSafeGoal: "REMOVEHEALTHSAFEGOAL",
}

   const udpatedHealthSafeGoals = [];

   const ImportHealthSafeGoalsReducer = (updtGoals = udpatedHealthSafeGoals, actions) => {
       switch (actions.type) {
           case IMPHEALTHSAFEGOALAction.AddHealthSafeGoal:
                updtGoals.push(actions.payload);
                return updtGoals;

            case IMPHEALTHSAFEGOALAction.RemoveHealthSafeGoal:
                updtGoals =[];
                return updtGoals;

            default:
                return updtGoals;
       }
    }
    export default ImportHealthSafeGoalsReducer;